
import { Component, Mixins, Prop } from "vue-property-decorator";
import SummaryMixin from "@/views/summary/summary.mixin";
import moment, { Moment } from "moment";

@Component
export default class UtoxResult extends Mixins(SummaryMixin) {
  @Prop() utoxResultShow!: boolean;
  @Prop() participantId!: number;
  @Prop() observationDate!: string;
  @Prop() clientId!: number;

  loading = false;

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("Summary/fetchUtoxById", {
        startDate: moment(this.observationDate).format("YYYY-MM-DD"),
        participantId: this.participantId, 
        clientId: this.clientId
      })
    ];
    await Promise.all(fetch);
  }

  closeModal() {
    this.$emit('update:utoxResultShow', false);
  }
}
